class DynamicTimer {
  constructor({
    duration = 60,
    elementId = 'dynamic-timer',
    persistKey = null,
    disableSelector = null,
    onTick = () => {},
    onComplete = () => {},
  }) {
    this.duration = duration;
    this.remaining = duration;
    this.element = document.getElementById(elementId);
    this.persistKey = persistKey;

    this.disableElement = disableSelector ? document.querySelector(disableSelector) : null;

    this.onTick = onTick;
    this.onComplete = onComplete;

    this.interval = null;
    this.endTime = null;

    if (this.persistKey) this.restoreState();

    this.applyDisabledState();
  }

  start() {
    if (!this.element) return console.warn('Timer element not found');

    if (this.interval) return;

    // Calculate end time
    this.endTime = Date.now() + this.remaining * 1000;

    this.disableSection(true);
    this.tick();

    this.interval = setInterval(() => this.tick(), 500);
  }

  tick() {
    const now = Date.now();
    this.remaining = Math.max(0, Math.round((this.endTime - now) / 1000));

    this.render();
    this.onTick(this.remaining);

    if (this.persistKey) this.saveState();

    if (this.remaining <= 0) {
      this.stop(); // Stop the timer
      this.clearState(); // Clear persisted state
      this.disableSection(false); // Enable the section
      this.onComplete(); // Call completion callback
    }
  }

  stop() {
    clearInterval(this.interval);
    this.interval = null;
  }

  pause() {
    this.stop();
  }

  resume() {
    if (this.remaining > 0) this.start();
  }

  reset(newDuration = null) {
    this.stop();
    this.remaining = newDuration ?? this.duration;
    this.endTime = null;
    this.clearState();
    this.render();
    this.disableSection(false);
  }

  destroy() {
    this.stop();
    this.clearState();
    this.disableSection(false);
  }

  render() {
    if (!this.element) return;

    const m = Math.floor(this.remaining / 60)
      .toString()
      .padStart(2, '0');

    const s = (this.remaining % 60).toString().padStart(2, '0');

    this.element.textContent = `${m}:${s}`;
  }

  /** ------------ Disable Section ----------- **/
  disableSection(state) {
    if (!this.disableElement) return;

    this.disableElement.style.display = state ? 'none' : 'block';
    this.element.style.display = state ? 'block' : 'none';
    this.disableElement.previousElementSibling.style.display = state ? 'block' : 'none';
  }

  applyDisabledState() {
    if (!this.persistKey) return;
    if (this.remaining > 0 && this.remaining !== this.duration) {
      this.disableSection(true);
    }
  }

  /** ------------ Persistence ------------- **/
  saveState() {
    sessionStorage.setItem(
      this.persistKey,
      JSON.stringify({
        endTime: this.endTime,
        duration: this.duration,
      })
    );
  }

  restoreState() {
    const data = sessionStorage.getItem(this.persistKey);
    if (!data) return;

    const { endTime, duration } = JSON.parse(data);

    const diff = Math.round((endTime - Date.now()) / 1000);

    this.duration = duration;
    this.remaining = diff > 0 ? diff : duration; // reset to full duration if expired

    if (diff > 0) this.start();
  }

  clearState() {
    if (this.persistKey) sessionStorage.removeItem(this.persistKey);
  }
}
